<template>
    <div>
        <v-tooltip bottom>
            <template v-slot:activator="{ on }">
                <v-chip small label v-on="on" :color="color" class="ma-1">{{ initials }}</v-chip>
            </template>
            <span>{{ fullName }}</span>
        </v-tooltip>
    </div>
</template>

<script>
    import _ from 'lodash'

    let parenthesesContentRegexp = /\([^)]*\)/g

    export default {
        name: 'Initials',
        props: {
            fullName: String,
            color: {
                type: String,
                default: "#e0e0e0"
            }
        },
        computed: {
            initials () {
                let words = _.words(_.trim(_.replace(this.fullName, parenthesesContentRegexp, '')))

                let initials = ''
                for (let word of words) {
                    initials += _.toUpper(word[0])
                }

                return initials
            }
        }
    }
</script>

<style scoped>

</style>